<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="80px"
    >
      <el-form-item label="机构名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="机构名称"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="dataForm.phone" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="机构编码" prop="orgCode">
        <el-input v-model="dataForm.orgCode" placeholder="机构编码"></el-input>
      </el-form-item>
      <el-form-item label="机构地址" prop="address">
        <el-input v-model="dataForm.address" placeholder="机构地址"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="description">
        <el-input
          type="textarea"
          v-model="dataForm.description"
          placeholder="机构介绍"
        ></el-input>
      </el-form-item>
   <!--   <el-form-item label="教师数量">
        <el-input-number
          disabled="true"
          v-model="teacherNum"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="学生数量">
        <el-input-number
          disabled="true"
          v-model="studentNum"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>-->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" :loading="loading"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      teacherNum: 0,
      studentNum: 0,
      dataForm: {
        name: "",
        phone: "",
        orgCode: "",
        address: "",
        description: ""
      },
      dataRule: {
        name: [
          { required: true, message: "机构名称不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
        ],
        orgCode: [
          {
            required: true,
            message: "请输入机构编码并最长为10位数",
            trigger: "blur",
          },
          { max: 10, message: "长度在10个字符之内", trigger: "blur" },
        ],
        address: [{ required: true, message: "地址不能为空", trigger: "blur" }],
        description: [
          { required: true, message: "简介：文字不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    init(id) {
      this.dataForm.id = id;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`sys/org/info/${this.dataForm.id}`),
            method: "get",
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.dataForm.name = data.sysOrg.name;
              this.dataForm.orgCode = data.sysOrg.orgCode;
              this.dataForm.phone = data.sysOrg.phone;
              this.dataForm.address = data.sysOrg.address;
              this.dataForm.description = data.sysOrg.description;
              this.teacherNum = data.sysOrg.teacherNum;
              this.studentNum = data.sysOrg.studentNum;
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http({
            url: this.$http.adornUrl(
              `sys/org/${!this.dataForm.id ? "save" : "update"}`
            ),
            method: `${this.dataForm.id ? "put" : "post"}`,
            data: this.$http.adornData(this.dataForm),
          })
            .then(({ data }) => {
              if (data && data.code === 0) {
                this.$message({
                  message: this.dataForm.id ? "更新成功" : "新增成功",
                  type: "success",
                });
                this.visible = false;
                this.$emit("refreshDataList");
              } else {
                this.$message.error(data.msg);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
